import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

class BlockSliderMedias {
  constructor() {
    this._init();
  }

  _init() {
    new Swiper('.slider-medias__swiper', {
      direction: 'horizontal',
      slidesPerView: 1,
      spaceBetween: 20,
      grabCursor: true,
      // preventInteractionOnTransition: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 24
        },
        1025: {
          slidesPerView: 2,
          spaceBetween: 24
        }
      },
      modules: [Navigation]
    });
  }
}

export const blockSliderMedias = new BlockSliderMedias();
